import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useAtomValue } from "jotai";
import { accessTokenAtom, tokenAtom } from "src/utils/auth/auth-atoms";
import { authService } from "src/utils/auth/auth-service";
import { AppStore } from "src/utils/jotai";
import { queryClient } from "src/utils/query-client";

export const getToken = () => {
  const token = AppStore.get(accessTokenAtom);
  return token;
};

export function useToken() {
  const token = useAtomValue(tokenAtom);
  const navigate = useNavigate();

  const logout = useCallback(async () => {
    // Cancel all ongoing queries to prevent them from completing after logout
    await queryClient.cancelQueries();
    // Clear the query cache to remove any sensitive data
    queryClient.clear();

    await authService.logout();
    navigate("/");
  }, [navigate]);

  return { loggedInUser: token, logout };
}
